"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionProps = exports.NEWSLETTER_DIALOG_SUBMIT = exports.NEWSLETTER_DIALOG = void 0;
const NEWSLETTER_DIALOG = exports.NEWSLETTER_DIALOG = 'newsletter-dialog';
const NEWSLETTER_DIALOG_SUBMIT = exports.NEWSLETTER_DIALOG_SUBMIT = 'newsletter-dialog-submit';
const transitionProps = exports.transitionProps = {
  timeout: 0
};
